// TODO: replace console.error with logger
let reportErrorInterface = () =>
  console.warn('initialize global reportErrorInterface with crashReporterInterfaceInit first...'); // eslint-disable-line no-console
let addBreadcrumbInterface = () => {};

export const crashReporterInterfaceInit = ({ reportError, addBreadcrumb }) => {
  reportErrorInterface = reportError || reportErrorInterface;
  addBreadcrumbInterface = addBreadcrumb || addBreadcrumbInterface;
};

export const reportError = (error, customDetails, reportOverrides) =>
  reportErrorInterface?.(error, customDetails, reportOverrides);
export const addBreadcrumb = (name, metadata, type) => addBreadcrumbInterface?.(name, metadata, type);
